import SettingsBenchmarkingContainer from './containers/SettingsBenchmarkingContainer';

export default SettingsBenchmarkingContainer;
